module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_LandingBg-sm.3f83c885.jpg";